<div class="p-6">
  <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
    <h3 class="font-bold">{{ '::SettlementOfCommissions' | abpLocalization }}</h3>
  </div>

  <div class="flex flex-col md:flex-row gap-2 mt-3">
    <app-metro-date-input-picker class="flex-1" [modeInput]="'range'" [startDateInput]="dateRange.start"
      [endDateInput]="dateRange.end" (rangeSelectedChange)="onDateRangeChange($event)" autocomplete="off">
    </app-metro-date-input-picker>

    <app-metro-form-select [placeholder]='"::Sommelier" | abpLocalization' [options]="sommelierOptions"
      [(ngModel)]="selectedSommelier" (selectionChange)="onSommelierChange($event)" class="flex-1">
    </app-metro-form-select>

    <app-metro-form-select [placeholder]='"::Status" | abpLocalization' [options]="statusOptions"
      [(ngModel)]="selectedStatus" (selectionChange)="onStatusChange($event)" class="flex-1">
    </app-metro-form-select>

    <app-metro-button
        [text]="'::GenerateExcel' | abpLocalization"
        variant="secondary"
        (click)="generateExcel()"
                [disabled]="!dateRange.start || !dateRange.end"
                [size]="'lg'"
                  [loading]="isLoading"

       >
      </app-metro-button>

  </div>

  <div class="flex flex-col overflow-x-auto rounded-lg border-1 border-gray-700">
     <app-metro-table
      [columns]="columns"
      [data]="reportData"
      [pageSize]="pageSize"
      [isServerPaginated]="true"
      [totalItems]="totalCount"
      [(currentPage)]="currentPage"
      (pageChange)="onPageChange($event)">
    </app-metro-table>
  </div>
</div>
